// ================================================================
//  <bm-id> — one shared fingerprint-icon + hex ID renderer, for every raw
//  entity ID reading in the app (job/client/resource/interceptor/
//  notification/biz-event/template/agent ID, ...).
//
//  Consolidates what used to be half a dozen independently-hand-rolled
//  shortening mechanisms — `.slice(-10)`, `| limitTo:-10`, a local
//  `limitLastChars` filter, a per-controller `shortId(id, n)` helper,
//  some with a leading '…', most without, some uppercased, most not —
//  now there is exactly one visual shape (tag icon + monospace ID) and
//  one shortening rule (strip dashes, keep the last N chars, uppercase
//  — the same rule <bm-user> already uses for a user's own ID), so IDs
//  read the same everywhere.
//
//  Usage:
//    <bm-id value="client.id"></bm-id>
//
//    <!-- Full, untruncated ID (e.g. next to its own copy-to-clipboard
//         button) — pass full="true" instead of relying on shortening. -->
//    <bm-id value="agent.agentId" full="true"></bm-id>
//
//    <!-- Compact — no padding/background, just icon + value, for a
//         tight table cell. -->
//    <bm-id value="job.jobId" compact="true"></bm-id>
//
//  Bindings:
//    value   ('<') the raw ID (UUID or any string) — or null/undefined,
//            which renders emptyText instead of a blank badge.
//    length  ('<') how many trailing characters to keep when shortening.
//            Defaults to 10.
//    full    ('<') boolean — show the entire ID as-is (no shortening).
//    label   ('@') optional caption under the value — ignored in
//            compact mode.
//    variant ('@') 'neutral' (default) | 'success' | 'warning' | 'danger'.
//    compact   ('<') boolean — strips padding/background/border and the
//              label, for table cells and other tight spaces. Also adds
//              a hover title with the full ID, since compact IDs are
//              always shown shortened.
//    emptyText ('@') shown in place of the value when missing — defaults
//              to 'N/A'.
// ================================================================

angular.module('bizmetryApp').component('bmId', {
  bindings: {
    value: '<',
    length: '<',
    full: '<',
    label: '@',
    variant: '@',
    compact: '<',
    emptyText: '@'
  },
  template: `
    <span class="bm-id"
          title="{{ $ctrl.compact && !$ctrl.full ? ($ctrl.value || '') : '' }}"
          ng-class="['bm-id--' + ($ctrl.variant || 'neutral'), $ctrl.compact ? 'bm-id--compact' : '', $ctrl.full ? 'bm-id--full' : '']">
      <md-icon class="bm-id-icon">fingerprint</md-icon>
      <span class="bm-id-text">
        <span class="bm-id-value">{{ $ctrl.formatted() }}</span>
        <span class="bm-id-label" ng-if="$ctrl.label && !$ctrl.compact">{{ $ctrl.label }}</span>
      </span>
    </span>
  `,
  controller: function () {
    var vm = this;
    vm.formatted = function () {
      if (!vm.value) { return vm.emptyText || 'N/A'; }
      if (vm.full) { return vm.value; }
      var stripped = String(vm.value).replace(/-/g, '');
      var len = vm.length || 10;
      return stripped.slice(-len).toUpperCase();
    };
  }
});
